import React from "react";

export const FollowUs = () => {
  return <div></div>;
};
